const SUPPORTED_EXTENSIONS = new Set(["pdf", "jpg", "jpeg", "png"]);

export type BuildS3ObjectKeyOptions = {
  now?: Date;
  uniqueId?: string;
};

const pad = (value: number): string => String(value).padStart(2, "0");

const localDateStamp = (now: Date): string =>
  `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;

const normalizeExtension = (fileName: string): string | null => {
  const raw = fileName.split(".").pop()?.toLowerCase();
  if (!raw || !SUPPORTED_EXTENSIONS.has(raw)) {
    return null;
  }
  return raw === "jpeg" ? "jpg" : raw;
};

export const buildS3ObjectKey = (
  clientId: string,
  originalFileName: string,
  options: BuildS3ObjectKeyOptions = {}
): string | null => {
  const extension = normalizeExtension(originalFileName);
  if (!clientId || !extension) {
    return null;
  }

  const dateStamp = localDateStamp(options.now ?? new Date());
  const uniqueId = options.uniqueId ?? crypto.randomUUID();

  return `${clientId}/${dateStamp}_${extension}_${uniqueId}.${extension}`;
};
